import { GrpcWebFetchTransport } from "@protobuf-ts/grpcweb-transport";

export const transport = new GrpcWebFetchTransport({
  format: "binary",
  baseUrl: process.env.REACT_APP_GRPC_URL || "",
});
